import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { createFileSuccess, createPromptFailure, saveFileOnly } from '../../add-prompt/state/add-prompt.actions';
import { PromptDetailView } from '../models/prompt-detail-view.model';
import { GetPromptDetail_prompt } from '../queries/generated/GetPromptDetail';
import * as PromptDetailActions from './prompt-detail.actions';

export const promptDetailFeatureKey = 'promptDetail';

export interface State {
   prompt: PromptDetailView | null;
   callState: CallState;
   queryComplete: boolean;
}

export const initialState: State = {
   callState: LoadingState.Init,
   prompt: null,
   queryComplete: false,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(PromptDetailActions.promptDetailLoad, PromptDetailActions.promptDetailCancel, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         prompt: null,
      };
   }),
   on(PromptDetailActions.loadPromptDetailSuccess, (state, action) => {
      const prompt: GetPromptDetail_prompt = action.data;
      return {
         ...state,
         callState: LoadingState.Loaded,
         prompt: {
            ...prompt,
            createUser: prompt.createUser as string | null,
            updateUser: prompt.updateUser as string | null,
         },
      };
   }),
   on(PromptDetailActions.loadPromptDetailFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(PromptDetailActions.savePromptDetail, saveFileOnly, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(
      PromptDetailActions.savePromptDetailFailure,
      PromptDetailActions.promptDetailAccessDenied,
      PromptDetailActions.uploadWrongFileType,
      createPromptFailure,
      createFileSuccess,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   ),
   on(PromptDetailActions.deleteFileSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         queryComplete: true,
      };
   })
);
